export const LOCAL_ICU_STREAM_PREFIX = 'local-media-stream:'

declare global {
    interface Window {
        __vcashLocalIcuStreams?: Record<string, MediaStream>
    }
}

export function isLocalIcuMediaStreamUrl(streamUrl: string): boolean {
    return streamUrl.startsWith(LOCAL_ICU_STREAM_PREFIX)
}

export function getLocalIcuMediaStreamId(streamUrl: string): string | null {
    if (!isLocalIcuMediaStreamUrl(streamUrl)) {
        return null
    }
    return streamUrl.slice(LOCAL_ICU_STREAM_PREFIX.length)
}

export function getLocalIcuMediaStream(streamUrl: string): MediaStream | null {
    const streamId = getLocalIcuMediaStreamId(streamUrl)
    if (!streamId || typeof window === 'undefined') {
        return null
    }
    return window.__vcashLocalIcuStreams?.[streamId] ?? null
}

export function registerLocalIcuMediaStream(
    streamId: string,
    stream: MediaStream
): string {
    if (typeof window !== 'undefined') {
        window.__vcashLocalIcuStreams = window.__vcashLocalIcuStreams ?? {}
        window.__vcashLocalIcuStreams[streamId] = stream
    }
    return `${LOCAL_ICU_STREAM_PREFIX}${streamId}`
}

export function unregisterLocalIcuMediaStream(streamId: string): void {
    if (typeof window === 'undefined') {
        return
    }
    delete window.__vcashLocalIcuStreams?.[streamId]
}

export function isPlayableIcuStreamUrl(streamUrl: string): boolean {
    return (
        isLocalIcuMediaStreamUrl(streamUrl) || streamUrl.startsWith('blob:')
    )
}
